<template>
    <div class="top-box">
      <div class="box"  @click="onclick" :key="index"  >
        <div :id="'itxst_'+indexStr">
          <div v-for="(item, i) in tempTags" :key="i" class="dis-tab">
            <div>{{ item }}</div>
            <i class="el-icon-close" @click="removeTag(i, item)"></i>
          </div>
        </div>
        <input
          v-show="isShowInput"
          :placeholder="placeholder"
          v-model="currentVal"
          maxlength="20"
          @keyup.enter="addTags"
          class="input-tag"
          ref="inputTag"
          type="text"
        />
      </div>

      <div v-if="isRepeat" style="color: #F77073;">
        {{tmpRepeatMsg }}
      </div>

    </div>

</template>

<script>
import Sortable from 'sortablejs'
export default {
  components: {

  },
  props: {
    placeholder: String,
    deleteConfirmMsg: String,
    repeatMsg: String,
    index: {
      type: Number,
      default: 0
    },
    // indexStr与index的区别，都是为了父组件列表中唯一查找，根据需求自己选择
    indexStr: {
      type: String,
      default: ''
    },
    tags: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      currentVal: '',
      isShowInput: true,
      isRepeat: false,
      tmpRepeatMsg: '',
      tempTags: JSON.parse(JSON.stringify(this.tags))
    }
  },
  created() {
    this.initDragSort()
  },
  mounted() {
  },
  filters: {

  },
  watch: {
    tags: {
      handler(n, o) {
        this.isShowInput = (o.length <= 29)
        if (n !== o) {
          this.$emit('getTags', this.index, this.indexStr, n)
          this.tempTags = JSON.parse(JSON.stringify(n))
          this.$forceUpdate()
        }
      },
      deep: true
    }

  },
  methods: {
    initDragSort() {
      console.log('拖拽 子组件' + 'itxst_' + this.indexStr)
      // 支持拖拽排序
      this.$nextTick(() => {
        let that = this
        const el = document.getElementById('itxst_' + this.indexStr)
        let sortable = Sortable.create(el, {
          onEnd: ({oldIndex, newIndex}) => {
            // 交换位置
            const arr = this.tags
            const page = arr[oldIndex]
            arr.splice(oldIndex, 1)
            arr.splice(newIndex, 0, page)
            // let newTags = []
            // // 获取拖动后的排序
            // var arr = sortable.toArray()
            // // arr数组里的值是 data-id 的顺序
            // arr.forEach((item, index) => {
            //   newTags.push(that.tags[item])
            // })
            // // sort
            // this.$emit('getTags', this.index, this.indexStr, newTags)
          }
        })
      })
    },
    onclick() {
      this.$nextTick(() => {
        this.$refs.inputTag.focus()
      })
    },
    addTags() {
      let that = this
      if (this.currentVal && this.currentVal.trim()) {
        let sameList = this.tags.filter((e) => {
          return e.toLowerCase() == that.currentVal.trim().toLowerCase()
        })
        if (sameList.length > 0) {
          this.isRepeat = true
          this.tmpRepeatMsg = this.repeatMsg.replace('{tag}', this.currentVal.trim())
        } else {
          this.isRepeat = false
          this.tempTags.push(this.currentVal.trim())
          this.$emit('getTags', this.index, this.indexStr, this.tempTags)
        }
        // 清空输入框
        this.currentVal = ''
      }
    },

    removeTag(index, item) {
      this.$confirm(this.deleteConfirmMsg.replace('{value}', item), '', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        confirmButtonClass: 'confirm-btn',
        cancelButtonClass: 'cancel-btn',
        type: 'warning'
      }).then(() => {
        this.tempTags.splice(index, 1)
        this.$emit('getTags', this.index, this.indexStr, this.tempTags)
      }).catch(() => {
        console.log('取消删除')
      })
    }
  }
}
</script>

<style lang="less">
.confirm-btn{
    background: #262B2F !important;
    color: #FFFFFF !important;
    border-color:#262B2F !important;
}
.cancel-btn:hover,.cancel-btn:active,.cancel-btn:focus{
  background:unset !important;
  color: unset !important;
}

</style>
<style scoped lang="less">

div{
  display: flex;
}
.top-box,.box{
  width: 350px;
  box-sizing: border-box;
  position: relative;
}

.top-box{
  flex-direction: column;
}

.box{
  width: 100%;
  min-height: 38px;
  border: 1px solid #707070;
  flex-wrap: wrap;
  .dis-tab{
    margin: 5px 0 5px 10px;
    background: #262B2F;
    color: #FFFFFF;
    height: 28px;
    line-height: 28px;
    padding: 0 15px;
    position: relative;
    font-size: 13px;
    text-align: center;
    font-weight: 500;
    border-radius: 3px;
    cursor: move;
    /deep/ .el-icon-close{
      position: absolute;
      font-size: 5px;
      right: 0px;
      cursor: pointer;
    }
  }
  .input-tag{
    margin-left: 10px;
    height: 38px;
    min-width: 210px;
    max-width: 100%;
    border: none;
    outline: none;
    &:focus{
      border: none;
    }
  }

}
#itxst div {
  cursor: move;
}
</style>



// WEBPACK FOOTER //
// src/pages/components/form/input-tag.vue